module.exports = __webpack_public_path__ + "static/media/hcr-tm-automated-white-with-text.ec4a1ca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hcr-tm-automated-white-with-text.png
// module id = 1482
// module chunks = 0